import React from 'react';
import { Select } from 'antd';
import i18n, { locale } from '../../../i18n';
import locales, { getLocale } from '../../../i18n/locales';
import { setLocale } from 'yup';

export function LanguageSelector({ style }: { style?: React.CSSProperties }) {
  const onChangeHandler = (value: string) => {
    i18n.changeLanguage(value).then(() => {
      const validationLocale = getLocale(locale()) || undefined;

      if (validationLocale) {
        setLocale(validationLocale.validation);
      }
    });
  };
  return (
    <Select
      style={style}
      onSelect={onChangeHandler}
      value={locale()}
      className="language-selector"
      optionLabelProp="label"
      dropdownMatchSelectWidth={false}
    >
      {Object.entries(locales).map(([locale, item]) => (
        <Select.Option value={locale} label={item.icon + ' ' + item.shortTitle}>
          {item.icon}&nbsp;
          <span>{item.title}</span>
        </Select.Option>
      ))}
    </Select>
  );
}
